const namespaced = true;

const defaultState = () => {
  return {
    loading: false,
    companies: [],
    locations: [],
    companyFilter: "",
    selectedLocations: [],
    multiFilter: [],
    statusFilter: [],
    tagSelection: [],
    vehicles: []
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_VEHICLES(state, vehicles) {
    state.vehicles = vehicles;
  },
  SET_COMPANY_FILTER(state, companyFilter) {
    state.companyFilter = companyFilter;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_COMPANIES(state, companies) {
    state.companies = companies;
  },
  SET_LOCATIONS(state, locations) {
    state.locations = locations;
  },
  REMOVE_MULTI_FILTER(state, index) {
    state.multiFilter.splice(index, 1);
  },
  SET_MULTI_FILTER(state, multiFilter) {
    state.multiFilter = multiFilter;
  },
  SET_STATUS_FILTER(state, statusFilter) {
    state.statusFilter = statusFilter;
  },
  REMOVE_STATUS_FILTER(state, index) {
    state.statusFilter.splice(index, 1);
  },
  SET_COMPANY(state, company) {
    state.company = company;
  },
  SET_TAG_SELECTION(state, tagSelection) {
    state.tagSelection = tagSelection
  },
  REMOVE_TAG_SELECTION(state, index) {
      state.tagSelection.splice(index, 1)
  }
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
